import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-motorcicle',
  templateUrl: './product-motorcicle.component.html',
  styleUrls: ['./product-motorcicle.component.css']
})
export class ProductMotorcicleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
